<template>
  <div class="page-auth-login">
    <SectionsPageBanner heading="Login" :min-height="240" />
    <AuthLogin />
  </div>
</template>

<script lang="ts" setup>
/**
 * Define page meta
 */
definePageMeta({
  authType: 'guest',
});

// DATA Definitions
//----------------------------------------------------------------------------------------------------------------------
const route = useRoute();

/**
 * @_HEAD Hook
 */
useHead({
  meta: [
    {
      name: 'canonical',
      content: 'https://www.newhomes.co.nz' + route.fullPath,
    },
  ],
});

const title = 'Login | New Homes - Access Your Personalized Home Buying Experience';
const description = 'Log in to your New Homes account to access saved listings, connect with agents, and personalize your new home search experience.';
useSeoMeta({
  title,
  description,
  ogTitle: title,
  ogDescription: description,
  ogImage: 'https://store.newhomeshub.co.nz/static-assets/new-homes-og-image-v2.jpg',
  twitterCard: 'summary_large_image',
  twitterTitle: title,
  twitterDescription: description,
  twitterImage: 'https://store.newhomeshub.co.nz/static-assets/new-homes-og-image-v2.jpg',
});
</script>
